import { useEffect, useMemo, useState } from "react";
import { useCheckbox } from "../../../../lib/hooks/formHooks";

export function useComparisonCheckbox(context, cameraId) {
    const {
        selectedCameras = [],
        addCamera,
        removeCamera,
        cameraCount
    } = context;

    const {
        value: checked,
        setValue: setChecked,
        bind
    } = useCheckbox(selectedCameras.some(({ id }) => id === cameraId));

    const [wasSelected, setWasSelected] = useState(false);

    const isSelected = useMemo(
        () => selectedCameras.some(({ id }) => id === cameraId),
        [selectedCameras, cameraId]
    );

    const disabled = useMemo(() => {
        return cameraCount >= 5 && !isSelected;
    }, [cameraCount, isSelected]);

    useEffect(() => {
        if (checked === isSelected) {
            return;
        }

        if (!checked && isSelected) {
            if (!wasSelected) {
                setChecked(true);
                setWasSelected(true);
                return;
            }

            removeCamera(cameraId);
            setWasSelected(false);
            return;
        }

        if (checked && !isSelected && wasSelected) {
            setChecked(false);
            setWasSelected(false);
            return;
        }

        addCamera(cameraId);
        setWasSelected(true);
    }, [checked, isSelected]);

    return {
        bind,
        disabled
    };
}
